import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import {
  BORDER_RADIUS,
  GRAY_DARKER,
  FONT_SIZE_4,
  FONT_WEIGHT_BOLD,
  GRAY_MEDIUM,
  FONT_SIZE_5,
  FONT_WEIGHT_NORMAL,
  GRAY_LIGHTER_3,
  FONT_SIZE_6,
  DANGER_COLOR,
  WHITE,
} from '../../styles/variables';
import { Button } from '../../styles/customComponents';

export const Container = styled.div`
  background-color: ${WHITE};
  height: 359px;
  width: 450px;
  border-radius: ${BORDER_RADIUS};
  display: flex;
`;

export const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin-top: 49px;
`;

export const ContentLoader = styled(Content)`
  ${flexPosition({ justify: 'center' })}
`;

export const Footer = styled.div`
  height: 80px;
  width: 100%;
  padding: 18px 15px;
  background-color: ${GRAY_LIGHTER_3};
  border-radius: ${BORDER_RADIUS};
  ${flexPosition({ align: 'center' })}
  justify-content: ${({ center }) => (center ? 'center' : 'space-between')};
  position: absolute;
  bottom: 0px;
`;

export const Title = styled.h2`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_4, FONT_WEIGHT_BOLD)}
  margin-top: 30px;
  padding: 0px 15px 0px 15px;
`;

export const Text = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_5, FONT_WEIGHT_NORMAL)}
  padding: 0px 15px 0px 15px;
  margin: 0px;
`;

export const CancelButton = styled(Button)`
  height: 45px;
  padding: 5px 15px;
  min-width: 140px;
  background-color: transparent;
  border-radius: ${BORDER_RADIUS};
  border: 1px solid ${GRAY_MEDIUM};
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
`;

export const DeleteButton = styled(Button)`
  height: 45px;
  padding: 5px 15px;
  min-width: 140px;
  border: none;
  background-color: ${DANGER_COLOR};
  border-radius: ${BORDER_RADIUS};
  ${fontStyle('#FFF', FONT_SIZE_6, FONT_WEIGHT_BOLD)}
`;

export const OKButton = styled(Button)`
  width: 142px;
`;

export const SendButton = styled(Button)`
  width: 110px;
`;

export const SendCountProducts = styled.div`
  ${flexPosition({ align: 'center', justify: 'center' })}
  svg {
    margin-right: 4px;
  }
`;

export const DivSelectList = styled.div`
  ${flexPosition({ justify: 'center' })}
  > div {
    margin-top: 35px;
    width: 291px;
    ul {
      max-height: 200px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/GenericModal/style.js